import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserService } from '../services/user.service';

export const userGuard: CanActivateFn = async (route, state) => {
    const userServ = inject(UserService);
    return new Promise((resolve, reject) => {
        userServ.getUser().subscribe((data) => {
            if (data) {
                resolve(true);
            }
            reject(false);
        });
    });
};
